import {Component, EventEmitter, Output} from '@angular/core';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-report-button',
	templateUrl: './report-button.component.html',
	styleUrls: ['./report-button.component.scss']
})
export class ReportButtonComponent {

	@Output() onClick: EventEmitter<void> = new EventEmitter<void>();
	translateContext = TranslateContext;

	constructor() {
	}
}

